export async function index({}) {
  const data = await this.$adminRepositories.companies.index();
  return data;
}

export async function destroy({}, payload) {
  const data = await this.$adminRepositories.companies.destroy(payload.id);
  return data;
}

export async function show({}, payload) {
  const data = await this.$adminRepositories.companies.show(payload);
  return data;
}
